module.exports = __webpack_public_path__ + "static/media/vivid-style.4fc2c65f.png";